module.exports = __webpack_public_path__ + "assets/img/logitechworkspace-lp-lifestyle-w960.41648e19.webp";